module.exports = __webpack_public_path__ + "static/media/HalfTimeShow_1.fccc7edc.mp4";